import React, { Component } from 'react';

import UrdUnitFeatures from "./UrdUnitFeatures";
import LockScreen from "./LockScreen";

export default class UrdUnits extends Component {

    constructor(props) {
        super();

        this.state = {
            units: props.units,
            isLocked: false,
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleLock = (islock) => {
        this.setState({ isLocked: islock });
    };

    handleToggle = (e) => {
        let units = this.state.units;
        const ind = e.currentTarget.getAttribute("index");
        const isActive = units[ind].isActive;
        units[ind].isActive = isActive == undefined ? false : !isActive;

        this.setState({ units: units });
    };

    render() {
        const units = this.state.units;
        const debug = this.props.debug;

        return (
            <LockScreen isLocked={this.state.isLocked}>
                <div className="features">
                    {/*<h3>{this.props.title} Features</h3>*/}
                    <table>
                        <tbody>
                            {units.map((unit, index) => (
                                <div class="urdUnit">
                                    <button onClick={this.handleToggle} index={index}>
                                        <table>
                                            <tbody>
                                                <tr className="urdUnitHeader">
                                                    <td>
                                                        <div>
                                                            Элемент № {unit.number}
                                                        </div>
                                                    </td>
                                                    <td className="selOptFeaPlusMinus">
                                                        <div>
                                                            <span>{unit.isActive == true || unit.isActive == undefined ? "-" : "+"} </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </button>
                                    <div class="cdsFeatureItemHeaderContent" style={unit.isActive == true || unit.isActive == undefined ? { display: "block" } : { display: "none" }}>
                                        <UrdUnitFeatures urdId={this.props.urdId} unitId={unit.id} unitNumber={unit.number} groups={this.props.groups} key={index} features={unit.cdsParametrs}
                                            configurationId={this.props.configurationId} debug={debug}
                                            extDisable={unit.externalEnable != undefined && unit.externalEnable == "false" ? true : false}
                                            handleUpdate={this.props.handleUpdate} updateConfiguration={this.props.updateConfiguration}
                                            handleLock={this.handleLock} showError={this.props.showError}/>
                                    </div>
                                </div>
                            ))}
                        </tbody>
                    </table>
                </div>
            </LockScreen>
        );
    }
}